var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 78,
    viewBox: "0 0 50 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3176 0.494224H26.6825H27.2088V68.226C28.7429 65.5159 30.6006 62.6927 32.7377 60.1093C37.113 54.8202 43.0056 50.1275 50 50.1275V54.0187C44.7839 54.0187 39.887 57.5716 35.736 62.5896C31.6369 67.5447 28.6018 73.5325 27.0801 77.5058L25.0001 77.1211L22.9199 77.5058C21.3983 73.5325 18.3631 67.5448 14.264 62.5896C10.113 57.5717 5.21612 54.0188 3.8147e-05 54.0188V50.1275C6.99447 50.1275 12.887 54.8202 17.2623 60.1093C19.3995 62.6928 21.2572 65.516 22.7912 68.226V0.494224H23.3176Z",
    fill: "#4AC6DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.8b04432b2815d2544c96e7e1f357b800.svg";
export { ForwardRef as ReactComponent };